import type { CohortConditionRange, CohortConditionSummary } from "@unbox/api";

// The value and its unit come back apart so a caller can play the unit down.
export type FormattedCondition = { value: string; unit?: string };

const currencyFormatter = (currency: string) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format;

const countFormatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format;

const formatRange = ({ min, max }: CohortConditionRange, format: (value: number) => string): string | null => {
  if (min === null && max === null) return null;
  if (min !== null && max !== null) return min === max ? format(min) : `${format(min)} – ${format(max)}`;
  return min !== null ? `> ${format(min)}` : `< ${format(max as number)}`;
};

export const formatConditionSummary = (
  condition: CohortConditionSummary | null | undefined,
  currency: string,
): FormattedCondition | null => {
  if (!condition) return null;

  if (condition.field === "gmvAmount") {
    const value = formatRange(condition, currencyFormatter(currency));
    return value ? { value } : null;
  }

  const value = formatRange(condition, countFormatter);
  return value ? { value, unit: "units" } : null;
};
